import React from "react";
import ModalContainer from "../../common/ModalContainer";
import { pointsConfig } from "../../../pointsConfig";

function CurrentRankProgressModal({ open, setOpen }) {
  return (
    <ModalContainer
      open={open}
      setOpen={setOpen}
      padding="px-4 py-6"
      title={""}
      header={<></>}
      childClassname={"rounded-t-lg max-w-[600px]"}
      onClickOutside={() => setOpen(false)}
    >
      <div className="w-full flex flex-col">
        <div className="w-full">
          <div className="relative overflow-x-auto flex flex-col scroll-hide">
            <div className="flex flex-col p-4 pb-0 w-full rounded-md">
              <div className="w-full flex flex-col gap-2 items-center">
                <div className="w-full flex items-center justify-center flex-col">
                  <span className="">{pointsConfig.ranks.legendary.label}</span>
                  <img
                    src={pointsConfig.ranks.legendary.icon}
                    alt=""
                    className="w-24 object-contain"
                  />
                  <span className="font-BrFirmaBold text-2xl ">10,389</span>
                </div>
                <div className="w-full flex flex-col items-center justify-center text-center ">
                  <span className="font-main font-bold text-lg">
                    Current Rank & Progress
                  </span>
                  <span className="text-sm text-[#6D7C94]">
                    Climb up the leaderboard for a bigger point bonus!
                  </span>
                </div>
                <hr className="w-full my-4 border border-gray-200" />
                <button
                  className="w-full h-12 text-white bg-primary1 rounded-md flex items-center justify-center"
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  Earn Points
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
}

export default CurrentRankProgressModal;
